export default __webpack_public_path__ + "static/media/790.3370fb32.jpg";